import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { MEDICAL_DETAILS_MAX, MEDICAL_KEYS, type MedicalAnswers, type MedicalKey } from "@/lib/trials/publicTrialQuestionnaire";
import { cn } from "@/lib/utils";

interface Props {
  value: MedicalAnswers;
  onChange: (key: MedicalKey, answer: MedicalAnswers[MedicalKey]) => void;
  t: (key: string) => string;
}

export function PublicTrialMedicalQuestionnaire({ value, onChange, t }: Props) {
  return <div>
    {MEDICAL_KEYS.map((key, index) => <div key={key} className="trial-medical-row">
      <div className="flex min-w-0 items-center gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/20 text-base font-bold text-foreground">{String.fromCharCode(65 + index)}</span>
        <div id={`medical-${key}`}><h3 className="text-sm font-semibold">{t(`medical.${key}.title`)}</h3><p className="mt-0.5 text-xs leading-snug text-muted-foreground">{t(`medical.${key}.question`)}</p></div>
      </div>
      <div role="group" aria-labelledby={`medical-${key}`} className="flex items-center gap-3">
        {[true, false].map(answer => <Button key={String(answer)} type="button" variant="ghost" aria-pressed={value[key].answer === answer}
          onClick={() => onChange(key, { answer, details: answer ? value[key].details : "" })}
          className="h-9 gap-2 px-1 text-xs hover:bg-primary/10">
          <span aria-hidden="true" className={cn("h-4 w-4 shrink-0 rounded-full border border-foreground", value[key].answer === answer && "border-primary bg-primary ring-2 ring-primary/25")} />
          {t(answer ? "fields.yes" : "fields.no")}
        </Button>)}
      </div>
      <Textarea rows={3} className="min-h-[5rem] resize-y" aria-label={`${t(`medical.${key}.title`)} — ${t("medical.details")}`} placeholder={t("medical.details")}
        value={value[key].details} disabled={value[key].answer !== true} maxLength={MEDICAL_DETAILS_MAX}
        onChange={event => onChange(key, { ...value[key], details: event.target.value })} />
    </div>)}
  </div>;
}